/**
 * Claims Types (MIRA 2.0)
 *
 * Claims-API'et er camelCase. Mapping sker i src/services/claimsService.ts
 * (næsten identitet, men typed + media-normalisering).
 */

export type ClaimStatus = 'open' | 'approved' | 'rejected';
export type PreferredOutcome = 'credited' | 'replacement_sent';
export type ClaimOutcome = 'credited' | 'replacement_sent' | 'rejected';
export type ProductHandling = 'discard' | 'gls_pickup';

export type StandardClaimType = 'pump_nozzle_defect' | 'damaged_on_arrival' | 'wrong_delivery' | 'other';
export type ElectronicsClaimType =
  | 'electronics_power_button' | 'electronics_magnet_ring' | 'electronics_display_error'
  | 'electronics_wont_turn_on' | 'electronics_brush_error';
export type ClaimType = StandardClaimType | ElectronicsClaimType;
export type ClaimTypeGroup = 'standard' | 'elektronik';

export interface Product {
  sku: string;
  productName: string;
  category: string;
  /** Produktbillede fra PIM-kataloget. null hvis API'et ikke leverer det (→ placeholder). */
  imageUrl?: string | null;
}

/** Vare-linje på et eksisterende (gemt) claim — media er et antal. */
export interface ClaimItem {
  id: number | null;
  sku: string;
  productName: string;
  quantity: number;
  claimType: ClaimType;
  description: string | null;
  orderNumber: string | null;
  isB2c: boolean;
  b2cCustomerName: string | null;
  b2cMobileNumber: string | null;
  media: number;
}

export interface Claim {
  id: number;
  status: ClaimStatus;
  source: string;
  salonName: string;
  createdByName: string;
  preferredOutcome: PreferredOutcome;
  outcome: ClaimOutcome | null;
  productHandling: ProductHandling | null;
  creditNoteNumber: string | null;
  processedByName: string | null;
  processedAt: string | null;
  createdAt: string;
  items: ClaimItem[];
}

export interface CustomerMatch {
  name: string;
  phone: string;
}

export interface OrderLookupResult {
  matched: boolean;
  source: 'webshop' | 'park_order' | null;
}

/** Aktør for et service-kald: medarbejder-header + evt. admin-salon-kontekst. */
export interface ClaimActor {
  employeeId: number;
}

// ---- Draft (create-flow; lever i ClaimsModule indtil submit) ----

export interface DraftItem {
  product: Product | null;
  claimType: ClaimType | null;
  quantity: number;
  description: string;
  orderNumber: string;
  isB2c: boolean;
  b2cMobileNumber: string;
  b2cCustomerName: string;
  media: File[];
}

export interface ClaimDraft {
  preferredOutcome: PreferredOutcome | null;
  items: DraftItem[];
}

/** Tom draft-item factory (genbruges i editor + container). */
export function emptyDraftItem(): DraftItem {
  return {
    product: null, claimType: null, quantity: 1, description: '',
    orderNumber: '', isB2c: false, b2cMobileNumber: '', b2cCustomerName: '', media: [],
  };
}
